import * as React from "react";
const SVGComp = () => (
  <svg
    width={400}
    height={200}
    viewBox="0 0 1187 798"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M313.999 781.5H867.999C867.999 781.5 929.999 758 940.499 708C950.999 658 921.498 674.5 931.999 584C942.5 493.5 1048.85 534.76 1090.5 479C1132.14 423.24 1127.5 355.5 1065.85 342.5C1004.21 329.5 843.211 220.02 906.855 168.26C970.499 116.5 729.211 47.7084 689.499 40.0001C485.999 0.500313 577.499 198.5 340.999 145.5C104.498 92.5003 -62.8386 309.813 92.4985 355.5C185.998 383 335.499 469 273.999 614L313.999 781.5Z"
      fill="#ECECEC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M658.974 77.1661C650.68 67.8814 643.774 55.3871 636.616 42.4361C635.238 39.9431 633.851 37.4332 632.443 34.9261C648.47 34.1974 667.216 35.675 689.499 40.0001C696.886 41.4341 711.251 44.9822 729.33 50.1413C723.648 53.8339 718.008 57.8925 712.495 61.8598C691.088 77.265 671.593 91.2936 658.974 77.1661ZM783.474 176.666C838.514 148.979 839.229 111.759 820.854 80.9682C885.461 106.668 941.601 140.002 906.855 168.26C861.525 205.126 930.154 271.273 995.678 310.985C999.247 324.372 1001.06 338.95 1002.88 353.615L1002.88 353.617C1007.77 392.963 1012.74 432.936 1051.92 452.206C1070.65 461.417 1087.92 461.792 1104.35 456.826C1100.53 464.322 1095.9 471.762 1090.5 479C1072.95 502.492 1043.92 508.763 1015.41 514.921C976.253 523.381 938.075 531.628 931.999 584C926.204 633.937 932.59 651.296 937.714 665.225C941.875 676.539 945.205 685.59 940.499 708C929.999 758 867.999 781.5 867.999 781.5H363.014C365.707 754.16 353.589 724.344 341.361 694.255C332.125 671.532 322.827 648.653 319.797 626.568C315.506 595.293 301.89 581.331 285.404 577.646C290.361 552.856 288.962 530.061 282.869 509.257C294.38 511.939 307.502 510.852 322.166 504.659C345.722 494.711 373.68 491.294 401.873 487.848L401.874 487.848L401.875 487.848C411.611 486.658 421.374 485.464 430.995 483.997C435.582 505.372 438.387 527.982 441.206 550.701C450.533 625.89 460.01 702.28 534.759 739.105C624.319 783.226 696.415 721.261 769.542 658.41C805.055 627.887 840.812 597.155 878.93 578.263C995.539 520.472 939.631 432.852 878.93 390.267C848.44 368.876 811.888 394.792 778.607 418.388C748.349 439.841 720.795 459.376 702.958 439.703C691.235 426.773 681.474 409.374 671.357 391.339C649.147 351.748 625.217 309.092 575.042 303.928C557.825 302.155 538.996 302.934 520.399 306.169C508.464 289.075 493.875 272.351 479.22 255.551L479.219 255.551C457.301 230.425 435.232 205.128 421.666 178.159C416.928 168.74 411.911 160.912 406.694 154.498C434.299 155.241 455.27 150.941 472.132 143.576C472.7 147.992 473.242 152.43 473.785 156.873C480.384 210.867 487.089 265.722 539.974 292.166C603.337 323.849 654.345 279.352 706.082 234.219C731.208 212.301 756.505 190.232 783.474 176.666ZM323.82 142.098C96.5272 102.999 -59.0497 310.927 92.4985 355.5C133.5 367.559 185.269 390.867 225.293 425.467C223.82 414.408 223.598 403.382 224.666 393.159C228.375 357.66 259.006 340.73 287.436 325.016C300.387 317.858 312.881 310.953 322.166 302.659C336.294 290.039 322.265 270.545 306.86 249.138C289.915 225.591 271.306 199.731 286.666 178.159C296.368 164.534 309.325 151.251 323.82 142.098Z"
      fill="#E6E6E6"
    />
    <path
      d="M22 782.25H1173"
      stroke="black"
      strokeWidth={5.5}
      strokeLinecap="square"
    />
    <path
      d="M806.273 554.688L806.273 375"
      stroke="black"
      strokeWidth={5.75}
      strokeLinecap="square"
    />
    <path
      d="M900.164 464.034H714.001"
      stroke="black"
      strokeWidth={5.75}
      strokeLinecap="square"
    />
    <path
      d="M841.887 496.411L769.04 423.565"
      stroke="black"
      strokeWidth={5.75}
      strokeLinecap="square"
    />
    <path
      d="M841.887 423.565L769.04 496.411"
      stroke="black"
      strokeWidth={5.75}
      strokeLinecap="square"
    />
    <path
      d="M541.746 150.766L541.746 13"
      stroke="black"
      strokeWidth={5.75}
      strokeLinecap="square"
    />
    <path
      d="M613.73 81.2625L471 81.2625"
      stroke="black"
      strokeWidth={5.75}
      strokeLinecap="square"
    />
    <path
      d="M569.051 106.085L513.2 50.2344"
      stroke="black"
      strokeWidth={5.75}
      strokeLinecap="square"
    />
    <path
      d="M569.051 50.2344L513.2 106.085"
      stroke="black"
      strokeWidth={5.75}
      strokeLinecap="square"
    />
    <rect x={36} y={414} width={431} height={162} rx={55} fill="#B4B5BB" />
    <rect x={115} y={511} width={426} height={137} rx={55} fill="#484A50" />
    <rect x={126} y={518} width={352} height={123} rx={55} fill="#5E616B" />
    <path
      d="M969 425.377L905.78 285.877L1032.22 285.877L969 425.377Z"
      fill="#484A50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M813 20C782.624 20 758 44.6244 758 75.0001V139.021H935.942C942.45 139.021 947.726 144.297 947.726 150.805C947.726 157.313 942.45 162.589 935.942 162.589H758V279.639C758 310.015 782.624 334.639 813 334.639H978.751C1009.13 334.639 1033.75 310.015 1033.75 279.639V229.759H842.846C836.338 229.759 831.062 224.483 831.062 217.975C831.062 211.467 836.338 206.191 842.846 206.191H1033.75V102.49H907.66C901.151 102.49 895.876 97.2136 895.876 90.7054C895.876 84.1971 901.152 78.9212 907.66 78.9212H1033.75V75C1033.75 44.6243 1009.13 20 978.751 20H813Z"
      fill="#484A50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M831 57C800.624 57 776 81.6243 776 112V156.35H921.66C927.092 156.35 931.496 160.754 931.496 166.187C931.496 171.62 927.092 176.024 921.66 176.024H776V264.639C776 295.015 800.624 319.639 831 319.639H947C977.376 319.639 1002 295.015 1002 264.639V232.093H845.716C840.283 232.093 835.879 227.689 835.879 222.256C835.879 216.823 840.283 212.419 845.716 212.419H1002V125.857H898.837C893.404 125.857 889 121.453 889 116.02C889 110.587 893.404 106.183 898.837 106.183H1001.7C998.791 78.542 975.411 57 947 57H831Z"
      fill="#5E616B"
    />
    <rect x={62} y={444} width={368} height={16} rx={8} fill="white" />
    <rect x={62} y={480} width={368} height={16} rx={8} fill="white" />
    <rect x={144} y={539} width={368} height={16} rx={8} fill="white" />
    <rect x={145} y={577} width={368} height={16} rx={8} fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M833.725 768.824C834.568 765.074 835 761.268 835 757.416C835 696.987 728.668 648 597.5 648C466.332 648 360 696.987 360 757.416C360 761.268 360.432 765.074 361.275 768.824H833.725Z"
      fill="#2B2C2E"
    />
    <path
      d="M569.5 487.75C564 495.75 551 505 530.5 486.25C510 467.5 367.498 244.25 367.498 244.25C367.498 244.25 359.997 232.75 370.498 226.75C381 220.75 389.498 223.75 389.498 223.75C389.498 223.75 722.5 323.75 727 326.75C731.5 329.75 738.587 334.993 739.5 342.75C740.5 351.25 732.5 354.75 732.5 354.75L616 382.25C616 382.25 600.577 386.25 597.5 396.25C594.423 406.25 571.938 484.204 569.5 487.75Z"
      fill="#141414"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M157 166.843L245.843 78L280.03 112.187C274.196 113.805 267.068 115.925 259.368 118.531C239.742 125.172 215.88 135.136 200.482 148.273C190.133 157.101 180.335 170.155 172.449 182.292L157 166.843ZM261.772 125.635C271.236 122.432 279.829 119.975 286.143 118.3L334.686 166.843L333.067 168.462C332.531 168.421 331.992 168.381 331.45 168.342C308.081 166.657 278.54 166.649 256.106 174.071C237.859 180.107 217.52 193.311 202.05 204.668C200.631 205.71 199.249 206.74 197.908 207.751L177.874 187.717C185.742 175.458 195.414 162.455 205.35 153.978C219.584 141.835 242.264 132.236 261.772 125.635ZM206.121 215.964L245.843 255.686L322.225 179.304C301.044 178.277 277.485 179.111 259.718 184.989C243.292 190.423 224.175 202.691 208.856 213.938C207.928 214.619 207.016 215.295 206.121 215.964Z"
      fill="#26D07C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M878 586.231L904.329 559.903C916.574 567.766 929.556 577.426 938.022 587.35C950.165 601.584 959.764 624.264 966.365 643.772C967.292 646.511 968.156 649.177 968.958 651.736L956.231 664.463L878 586.231ZM943.727 582.482C934.91 572.146 921.877 562.359 909.753 554.478L927.05 537.181C930.232 537.488 933.562 537.832 936.997 538.219C957.182 540.491 980.595 544.18 998.212 549.981L1034.46 586.231L974.927 645.767C974.459 644.325 973.973 642.857 973.469 641.368C966.828 621.742 956.864 597.88 943.727 582.482ZM987.325 539.094L956.231 508L933.896 530.335C935.192 530.473 936.506 530.616 937.836 530.766C953.464 532.525 971.431 535.166 987.325 539.094Z"
      fill="#26D07C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M335.01 40.0284L304 71.0386L345.039 112.077L361.741 95.3749C355.001 85.8932 349.312 75.0102 348.239 64.2761C347.257 54.4608 341.743 46.3719 335.01 40.0284ZM365.725 91.3909L386.077 71.0386L345.039 29.9999L338.935 36.1033C346.242 43.0241 352.61 52.2075 353.761 63.7239C354.68 72.9071 359.564 82.572 365.725 91.3909Z"
      fill="#26D07C"
    />
  </svg>
);
export default SVGComp;
